import { default as _91_46_46_46slug_935AglwjVXQ8Meta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/[...slug].vue?macro=true";
import { default as indexz4M6JQgBbjMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/auth/index.vue?macro=true";
import { default as index8KtI4r7yCkMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93kGo8hzy5I5Meta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93PH2aPWHZnbMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_93tIbIUTHFVPMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_93Xsl11AGIO3Meta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/news/[slug].vue?macro=true";
import { default as organisationsGgM03SgOXXMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45eventsGUoeBVfJQXMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programsQmLo2nakYIMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as index7Ppt9Ern93Meta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/processes/index.vue?macro=true";
import { default as dungeonrbzGopyEerMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputsjmfgTZaVnDMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexcORadYp7q4Meta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/secret/index.vue?macro=true";
import { default as index3jci1aX2WeMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseData6sxcrrFdUeMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClassrnyQAc5bwtMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93NNrrbBOuQzMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexaSQU5ro7NzMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDatayN0dmutA5VMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFieldsuJHotkRHWgMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReports7ZO0DXef7DMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRights4QefhUNPnZMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_93EMUKqRe57zMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as indexmvNfJAS4MyMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesWPXy0rn3OcMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDataSl2wiCLe6DMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93VI3tK3eoAcMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexm0p4auFiDxMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivities9oWfZ9HCbEMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDatassgM0yRYDdMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93JwlZcXyRR6Meta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indexUNNp8P3LfoMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDatauCYW9YAteEMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93f9g6BG3UtiMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexgnePS0AnK5Meta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseDataCG11luLy4bMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClassovyzI96hI2Meta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedFormsysijMr5yL6Meta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_937DnNn9jtbQMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as indexnYtWMXTbR8Meta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivitiessPsyjfgZ7rMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseDataIKttzjBaaVMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriodsb2bot4C6KAMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as _91id_93HxhDturSsZMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as indexOHSA038a0yMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivitiesdQviEdKd2kMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDataVecpQAlvQUMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsRG7cqauD8DMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93Otm1pp771zMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexXOWeEj1zJbMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDatayPB6atLJssMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDataGMNYfSGd1tMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_93rYKCA49CMXMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as index7PpQ6PzUo9Meta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDataQzmVZ4ZAkbMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData.vue?macro=true";
import { default as _91id_931q8WulbjRCMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexEsSEBLPlSEMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroupsLC7ObpS3MMMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseData9ZnEBHzELnMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_93d5ci34MBgWMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as indexSrHNakm0lrMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parishesPQ0KIv3bs4Meta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivitiesJrAra01MurMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupsmCeu9ASxb2Meta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseDataJTeJPsCf8XMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconiasWWy6GPh8AZMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishesNnYVvkGCOgMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_93TjMsg64mhwMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as indexJzQTLeQwJjMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regionsJlAWXQdnHvMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehltsNH03fgJYFMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunBaseDataGZv5newe2sMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsF1mos3HbztMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93BHKmlbAFayMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as indexI7OnO1rqoBMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as payments7X8zSEbvcHMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/payments.vue?macro=true";
import { default as processActivitiesMDyq3ikRiRMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDataaxDCx6m5UqMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93C7L5K5QRveMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/processes/[id].vue?macro=true";
import { default as index3AhFZuGRmaMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/processes/index.vue?macro=true";
import { default as _91id_935i9tm0vv0GMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexCydtoIeosNMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProviders3afuHy51pTMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivities80XABbCQaNMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingsC1ByJJmNNTMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDataG3Sa14PvZdMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategorieswi7d0jlJnyMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConcept7g1lENmjulMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreementWhaW9qaOq8Meta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsers6Uoxi8DWTXMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93eXyNRaZwNcMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexpvS6fDg6QgMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisationsuWTEcSXtuwMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivities2jlUOEfGEJMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDatab5yObYGdNAMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignatureLT1Lch8ZiKMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93TM6PjqxKhnMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexglz983uNDrMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/users/index.vue?macro=true";
import { default as usersN7LeEQzUj5Meta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/users.vue?macro=true";
import { default as settingsQP35ENiV0cMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivities8wnbsozHDGMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseDataT1Ec9WHggLMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_936B0QBhd5UdMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as indexJO42cB83BCMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as serviceT0LU6zz1DaMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service.vue?macro=true";
import { default as languageVIPbMq3urRMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDataAjKRUZFmxHMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesh8VlE5ODtkMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreementkpWuswwSz7Meta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsers2TGeDx45VqMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93DLtxoILbcCMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDataUqmadDW7JqMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignaturerGENxPvuo2Meta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93B8mZciwqEnMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/users/[id].vue?macro=true";
import { default as indexhAqXtckxaPMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/users/index.vue?macro=true";
import { default as settingsf7ginqxjJSMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings.vue?macro=true";
import { default as signaturekzySSZqpEBMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/signature.vue?macro=true";
import { default as sportbizzICjQ1HKZCCMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/sportbizz.vue?macro=true";
import { default as _91id_93aEG8A5A5kPMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_93cGjMsB6Ma0Meta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as indexzEZoMEXSjAMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/statistics/index.vue?macro=true";
import { default as _91_46_46_46slug_93DTuhHiHZUCMeta } from "/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/wiki/[...slug].vue?macro=true";
import { default as sportbizzk99AObOvrmMeta } from "@/pages/sportbizz.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_935AglwjVXQ8Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexz4M6JQgBbjMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: index8KtI4r7yCkMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93kGo8hzy5I5Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93PH2aPWHZnbMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_93tIbIUTHFVPMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsGgM03SgOXXMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: index7Ppt9Ern93Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: serviceT0LU6zz1DaMeta?.name,
    path: "/service",
    meta: serviceT0LU6zz1DaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDataQzmVZ4ZAkbMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: index3jci1aX2WeMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93NNrrbBOuQzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexaSQU5ro7NzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_93EMUKqRe57zMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: indexmvNfJAS4MyMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93VI3tK3eoAcMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexm0p4auFiDxMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93JwlZcXyRR6Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indexUNNp8P3LfoMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93f9g6BG3UtiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexgnePS0AnK5Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_937DnNn9jtbQMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: indexnYtWMXTbR8Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_93HxhDturSsZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: indexOHSA038a0yMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93Otm1pp771zMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsRG7cqauD8DMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexXOWeEj1zJbMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93rYKCA49CMXMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: index7PpQ6PzUo9Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_931q8WulbjRCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parishesPQ0KIv3bs4Meta?.name,
    path: "parishes",
    meta: parishesPQ0KIv3bs4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_93d5ci34MBgWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regionsJlAWXQdnHvMeta?.name,
    path: "regions",
    meta: regionsJlAWXQdnHvMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_93TjMsg64mhwMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: payments7X8zSEbvcHMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93BHKmlbAFayMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: indexI7OnO1rqoBMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93C7L5K5QRveMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: index3AhFZuGRmaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/processes/index.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingsQP35ENiV0cMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProviders3afuHy51pTMeta?.name,
    path: "loginProviders",
    meta: loginProviders3afuHy51pTMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_935i9tm0vv0GMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexCydtoIeosNMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisationsuWTEcSXtuwMeta?.name,
    path: "organisations",
    meta: organisationsuWTEcSXtuwMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_93eXyNRaZwNcMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexpvS6fDg6QgMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: usersN7LeEQzUj5Meta?.name,
    path: "users",
    meta: usersN7LeEQzUj5Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93TM6PjqxKhnMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexglz983uNDrMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_936B0QBhd5UdMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: indexJO42cB83BCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/service/statisticProcesses/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsf7ginqxjJSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93DLtxoILbcCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93B8mZciwqEnMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: indexhAqXtckxaPMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signaturekzySSZqpEBMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/signature.vue")
  },
  {
    name: "sportbizz",
    path: "/sportbizz",
    meta: sportbizzICjQ1HKZCCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/sportbizz.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_93aEG8A5A5kPMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_93cGjMsB6Ma0Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: indexzEZoMEXSjAMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/statistics/index.vue")
  },
  {
    name: "wiki-slug",
    path: "/wiki/:slug(.*)*",
    meta: _91_46_46_46slug_93DTuhHiHZUCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250509154524/client/pages/wiki/[...slug].vue")
  },
  {
    name: "sportbizz",
    path: "/index/welcome/p/sportbizz",
    meta: sportbizzk99AObOvrmMeta || {},
    component: () => import("@/pages/sportbizz.vue")
  }
]